module.exports = {
  rwCollectionDate: 'RW揽收时间',
  omsReturnCode: 'OMS退货编号',
  defectReason: '质检结果',
  warehouseReceiptLineNumber: '入库单行号',
  receiptNumber: '入库单号',
  receiptCreationTime: '入库单创建时间',
  receiptStatus: '入库单状态',
  omsReturnRxchangeCode: 'OMS退换货编码',
  returnTrackingNumber: '退回快递单号',
  packageStatus: '包裹状态',
  rwCollectionTime: 'RW揽收时间',
  abnormalPackageNumber: '异常包裹号',
  processingStatus: '处理状态',
  qualityInspectionResult: '质检结果',
  exportResults: '导出结果',
  maxErrorTitle: '一次最多200行数据'
}
